import { Record } from 'immutable';
import _ from 'lodash';

const properties = {
  id: String(),
  name: String(),
};

export default class Skill extends Record(properties, 'Skill') {
  public readonly id!: string;

  public readonly name!: string;

  constructor(values: any = {}) {
    super(_.pick(values, Object.keys(properties)));
  }
}
